import { errorResponses } from '../../constants/errorCode'

export class CreateError {
  errName
  code = 500
  data
  constructor(errCode, errName, dataErr) {
    this.errName = errName ?? 'Response Error'
    this.errCode = this.code ?? errCode
    this.data = dataErr
  }

  /**
   *
   * @param {Number} code custome code error
   * @param {String} message custome error message
   * @returns throwing error with response
   */
  errorMessage() {
    const err = new Error()
    err.name = this.errName
    if (!this.data || this.data === 'undefined') {
      err.response = errorResponses[500]
      throw err
    }
    err.response = this.data
    throw err
  }
}
